import GanttChartPage from './GanttChartPage';

export default GanttChartPage;
